import { ProductType } from '@/shared/config/pages';

export const SERP_ECOMMERCE_LISTS: Partial<Record<ProductType, string>> = {
  [ProductType.TourOffer]: 'serpTour',
};

export const SERP_ECOMMERCE_IMPRESSIONS_PAGE_SIZE = 30;
